<template lang="html">
  <b-container>
    <b-row class="mb-4">
      <b-col v-if="user_doc_loaded" md="12">
        <h1>Upgrade from {{ user_plan.name }} to {{ target_plan.name }}</h1>
        <div v-if="estimate_loaded">
          <p v-if="result">
            Your current <strong>{{ user_plan.name }}</strong> subscription ends
            on {{ result.current_period_end | date_string }}.
          </p>
          <p>
            The pro-rated cost for this upgrade is
            {{ (upgrade_cost_estimate / 100) | toCurrency }} USD for the
            remainder of your subscription.
          </p>
          <p>
            We will process the payment using your card on file:
          </p>
          <p v-if="current_card">
            {{ current_card.brand }} ({{ current_card.last4 }}) exp.
            {{ current_card.exp_month }}/{{ current_card.exp_year }}.
          </p>
          <p>To accept this upgrade charge, click below.</p>
          <b-btn :disabled="upgradeInProgress" @click="complete_upgrade">
            Complete Upgrade
          </b-btn>
        </div>
        <div v-else>
          Loading estimate ...
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { stripe_payment_endpoint } from "@/defaults";

import axios from "axios";
import { plans } from "@/defaults";
import find from "lodash/find";
import { format } from "date-fns";
export default {
  name: "UpgradeProrated",
  components: {},
  filters: {
    date_string: function(value) {
      value = value * 1000;
      return format(new Date(value), "MMMM d, yyyy h:mm aa");
    },
    toCurrency: function(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },
  data() {
    return {
      upgrade_cost_estimate: 0,
      proration_date: 0,
      estimate_loaded: false,
      upgradeInProgress: false
    };
  },

  computed: {
    user_doc_loaded() {
      return this.$store.state.user_doc.loaded;
    },
    user_plan() {
      return this.$store.getters.user_plan;
    },
    target_plan() {
      if (this.$route.params.plan_id) {
        return find(plans, { plan_id: this.$route.params.plan_id });
      }
      return "";
    },
    result() {
      if (!this.$store.state.stripe_data) {
        // Possible that stripe_data is loading.
        return null;
      }
      if (this.$store.state.stripe_data.subscriptions) {
        return this.$store.state.stripe_data.subscriptions.data[0];
      }
      return null;
    },
    current_card() {
      if (!this.$store.state.stripe_data) {
        // Possible that stripe_data is loading.
        return null;
      }
      if (this.$store.state.stripe_data.default_source) {
        return this.$store.state.stripe_data.sources.data[0];
      } else {
        return null;
      }
    }
  },
  watch: {
    user_doc_loaded(value) {
      if (value) {
        this.load_estimate();
      }
    }
  },
  activated() {
    this.estimate_loaded = false;
    if (this.user_doc_loaded) {
      this.load_estimate();
    }
  },
  mounted() {
    this.estimate_loaded = false;
    if (this.user_doc_loaded) {
      this.load_estimate();
    }
  },
  methods: {
    load_estimate() {
      var _v = this;
      this.$store.dispatch("load_stripe_data");
      console.log("load_estimate");
      var change_preview_url = `${stripe_payment_endpoint}subscribe_change_preview/${this.$store.state.user.uid}/${this.$store.state.user_doc.stripe_result.customer}/${this.$store.state.user_doc.stripe_result.id}/${this.$route.params.plan_id}/`;

      console.log(change_preview_url);

      axios
        .get(change_preview_url)
        .then(result => {
          console.log(result.data);
          _v.estimate_loaded = true;
          _v.upgrade_cost_estimate = result.data.cost_estimate;
          _v.proration_date = result.data.proration_date;
        })
        .catch(e => {
          console.log(e);
        });
    },
    complete_upgrade() {
      var _v = this;
      _v.upgradeInProgress = true;
      console.log("complete_upgrade");
      var change_preview_url = `${stripe_payment_endpoint}subscribe_change/${this.$store.state.user.uid}/${this.$store.state.user_doc.stripe_result.customer}/${this.$store.state.user_doc.stripe_result.id}/${this.$route.params.plan_id}/${_v.upgrade_cost_estimate}/`;

      console.log(change_preview_url);

      axios
        .get(change_preview_url)
        .then(result => {
          console.log(result.data);
          this.$store.dispatch("toastMessage", "Upgrade complete.");
          this.$router.push({ name: "shows" });
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>

<style lang="css" scoped>
.card {
  min-height: 400px;
  padding-bottom: 30px;
}
.card-short {
  min-height: 380px;
}
.plan-button {
  position: absolute;
  bottom: 20px;
}
</style>
